// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-small div.modal-container{height:auto;width:500px;max-width:550px;min-width:500px}.form-group .btn-group.btn-group-toggle label.btn-primary{color:#fff;cursor:pointer}.modal-body{justify-content:center;display:flex;flex-direction:column}", ""]);
// Exports
module.exports = exports;
